import React, { useContext } from 'react';
import { Box, Divider } from '@mui/material';
import './MandaysToBeBilled.css';
import CustomTooltip from '../../../../../Components/custom_components/CustomTooltip/CustomTooltip';
import TextSkeleton from '../../../../../Components/Skeletons/TextSkeleton';
import { dashboardContext } from '../../../Dashboard';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { hasPrivilege } from '../../../../../utils/privileges';

const MandaysToBeBilled = () => {
    const navigate = useNavigate();
    const privileges = useSelector((state) => state?.privileges?.privileges)

    const { data, isLoading } = useContext(dashboardContext);
    const columns = ['Worksite', 'Man Days', 'Invoice Date'];


    // ---------------- NAVIGATION ---------------- //
    const handleViewNavigate = () => {
        navigate(`/finance/Finance/list`);
    };

    return (
        <Box className="mandays-container">
            <div className="mandays-header p-0">
                <div className='mandays-header p-0'>
                    <span className="mandays-title">
                        {isLoading ? <TextSkeleton width="50%" fontSize="3rem" /> : "Man days to be Billed"}
                    </span>

                    <span className="mandays-count">
                        {isLoading ? <TextSkeleton width="100%" fontSize="3rem" /> : data?.manDaysCount || "0"}
                    </span>
                </div>

                {isLoading ? <TextSkeleton width="100%" fontSize="3rem" /> :
                    hasPrivilege(privileges, "Finances", 20, 2) &&
                    <span className="viewAll" onClick={handleViewNavigate}>
                        View All
                    </span>}

            </div>

            <div className="mandays-column-container">
                {columns.map((item, index) => (
                    <span key={index} className="mandays-project-column">{isLoading ? <TextSkeleton width='50%' fontSize='3rem' /> : `${item}`}</span>
                ))}
            </div>
            <Divider />
            <Box className="mandays-project-list">
                {data?.manDaystoBilled?.length == 0 && !isLoading ? (<p className="no-data-message">No records found</p>) : (
                    data?.manDaystoBilled?.map((project, index) => (
                        <>
                            <div key={index} className="mandays-project-row">
                                <CustomTooltip title={project.Work_Site}>
                                    <span className="mandays-project-column mandays-project-worksite">{isLoading ? <TextSkeleton width='50%' fontSize='3rem' /> : `${project.Work_Site || 'N/A'}`}</span>
                                </CustomTooltip>
                                <span className="mandays-project-column mandays-project-duration">{isLoading ? <TextSkeleton width='50%' fontSize='3rem' /> : `${project.Total_Mandays || 0}`}</span>
                                <span className="mandays-project-column mandays-project-startDate">{isLoading ? <TextSkeleton width='50%' fontSize='3rem' /> : `${project.Last_Start_Date || 'N/A'}`}</span>
                            </div>
                            <Divider />
                        </>
                    ))
                )}

            </Box>
        </Box>
    );
};

export default MandaysToBeBilled;
